import { Injectable } from '@angular/core';
import { catchError, defaultIfEmpty, first, map, mergeMap, tap } from 'rxjs/operators';
import { AlertsApiService } from './api.service';
import { Observable, of } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { IAlertsState } from './state';
import { Lux } from '@roosevelt/common-ui-lib/core';

@Injectable({
  providedIn: 'root'
})
export class AlertsAsync {
  constructor(
    private readonly lux: Lux<{ bmtAlertsState: IAlertsState}>,
    private readonly alertsService: AlertsApiService,
  ) { }

  getBMTAlerts(req) {
      return of(req).pipe (
      first(),
      tap(() =>
        this.lux.set(state => state.bmtAlertsState, { isFetchingAlerts: true })),
      mergeMap(_request => this.alertsService.getBmtAlerts(req)),
      tap(results => {
        this.lux.set(state => state.bmtAlertsState, { alerts: results, isFetchingAlerts: false });
      }),
      catchError((err: HttpErrorResponse) => {
        let errorMessage = '';
        if (err?.error?.apiErrorList?.length > 0) {
          errorMessage = err.error.apiErrorList.map(err => err.errorMessage).join('\n');
        }
        this.lux.set(state => state.bmtAlertsState, { errors: errorMessage, isFetchingAlerts: false });
        return of(errorMessage);
      })
    );
  }

  getPaymentDueNotification(): Observable<boolean> {
    return this.alertsService.getPaymentDueNotification().pipe(
      tap(() => {
        this.lux.set(state => state.bmtAlertsState, {isFetchingAlerts: true});
      }),
      map(response => {
        this.lux.set(state => state.bmtAlertsState, {isFetchingAlerts: false});
        return response.status === 200;
      }),
      defaultIfEmpty(false),
      catchError(err => {
        const apiErrorList = err?.error?.apiErrorList;
        let errorMessage: string;
        if (apiErrorList?.length > 0) {
          errorMessage = apiErrorList.map(item => item.errorMessage).join('\n');
        } else if (err?.name === 'TimeoutError') {
          errorMessage = 'Timeout has occurred';
        } else {
          errorMessage = 'Internal server error';
        }
        this.lux.set(state => state.bmtAlertsState, {errors: errorMessage, isFetchingAlerts: false});
        return of(false);
      })
    );
  }
}
